import React, { useEffect, useState } from "react";
import InstructorSlideButton from "./InstructorSlideButton";
import InstructorUserSelector from "./InstructorUserSelector";
import { getData } from "../../services/Axios/Axios";
import { ApiUrl } from "../../config/apiConfig";
import { AdminUser } from "../../models/AdminUser";
import { confirmAction } from "../../utils/utils";

interface InstructorAccessControllerProps {
    formData: AdminUser;
    setFormData: React.Dispatch<React.SetStateAction<AdminUser>>;
}

const InstructorAccessController: React.FC<InstructorAccessControllerProps> = ({
    formData,
    setFormData
}) => {

    const [currentActiveTab, setCurrentActiveTab] = useState<string | null>("Coordinator")
    const [users, setAllUsers] = useState<AdminUser[]>([]);
    const TABS = ["Coordinator", "Developer", "Teacher", "Support", "Media"]

    const getAllUsers = async () => {
        const response = await getData(ApiUrl.listAdmins, {});
        setAllUsers(response.data);
    };

    useEffect(() => {
        getAllUsers();
    }, []);

    const getUsersByCurrentTab = () => {
        if (!currentActiveTab) return [];
        return users.filter((user) => user.adminType === currentActiveTab);
    }


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    return (
        <div className="px-3 border rounded-xl shadow-sm p-4 bg-white">
            {/* Main Instructor Toggle */}
            <div className="flex gap-3 relative items-center">

                <label className="flex items-center space-x-2 mb-3">
                    <input
                        checked={formData.permissions.includes("Instructors")}
                        type="checkbox"
                        onChange={(e) => {
                            confirmAction("you want change In", () => {

                                setFormData((prev) => ({ ...prev, permissions: prev.permissions.includes("Instructors") ? prev.permissions.filter((p) => p !== "Instructors") : [...prev.permissions, "Instructors"] }))
                            })

                        }}
                        className="h-4 w-4 rounded accent-greenBg"
                    />
                    <span className="font-bold">Instructor</span>
                </label>
                <div className=" absolute top-[-1.3rem] right-2">
                    <label className="text-xs text-gray-600 font-bold">ADMIN TYPE</label>
                    <select
                        className="w-full  border placeholder:text-[13px] placeholder:text-gray-500    border-gray-400 mt-[2px] hover:border-gray-600 rounded-[5px] bg-white text-gray-800 h-[32px] font-normal focus:outline-none focus:ring-[1.5px]  focus:ring-greenBg focus:border-transparent transition-all duration-300"
                        name="adminType"
                        value={formData.adminType}
                        onChange={(e) => {
                            handleChange(e as any)
                            const value = e.target.value;
                            if (!formData.instructorTabButtons.includes(value)) {
                                setFormData((prev) => ({ ...prev, instructorTabButtons: [...prev.instructorTabButtons, value] }))
                            }

                        }}
                    >
                        <option value="" disabled selected>
                            SELECT TYPE
                        </option>
                        <option value="Coordinator">Coordinator</option>
                        <option value="Developer">Developer</option>
                        <option value="Teacher">Teacher</option>
                        <option value="Support">Support</option>
                        <option value="Media">Media</option>
                    </select>
                </div>
            </div>

            {/* Role Buttons */}
            <div className="bg-[#f5f5f5] p-3 rounded-md">

                <div className=" flex flex-wrap gap-2 mb-3">
                    {TABS.map((tab) =>
                        <InstructorSlideButton
                            label={tab}
                            checked={formData.instructorTabButtons.includes(tab)}
                            onChange={(value: boolean) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    instructorTabButtons: value
                                        ? [...prev.instructorTabButtons, tab] // add
                                        : prev.instructorTabButtons.filter((t) => t !== tab), // remove
                                }));

                                if (value) {
                                    setCurrentActiveTab(tab);
                                }
                            }}
                            isActive={tab=== currentActiveTab}
                            onClickTab={(value: any) => setCurrentActiveTab(value)}
                        />

                    )}

                </div>

                <InstructorUserSelector currentActiveTab={currentActiveTab} formData={formData} setFormData={setFormData} users={getUsersByCurrentTab()}></InstructorUserSelector>

            </div>
        </div >
    );
}


export default InstructorAccessController;